module.exports = __webpack_public_path__ + "img/solution_info.09fbfd47.png";